import { render, staticRenderFns } from "./delivery-virtual.vue?vue&type=template&id=ece99df6&scoped=true"
import script from "./delivery-virtual.vue?vue&type=script&lang=js"
export * from "./delivery-virtual.vue?vue&type=script&lang=js"
import style0 from "./delivery-virtual.vue?vue&type=style&index=0&id=ece99df6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ece99df6",
  null
  
)

export default component.exports